import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import deleteUser from "./apis/deletUser";
import { toast } from "react-toastify";
import { logout } from "../../../../features/auth/authSlice";
import { clearUser } from "../../../../features/auth/userSlice";

function DangerZone() {
  const [confirming, setConfirming] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.user);

  const handleDeleteAccount = async () => {
    const res = await deleteUser(user?.userId);

    if (res.error) {
      toast.error(res.msg);
      setConfirming(false);
      return;
    }

    dispatch(logout());
    dispatch(clearUser());
    setConfirming(false);
    navigate("/");
  };

  return (
    <div className="mt-6 w-full rounded-2xl p-6 bg-black text-slate-100 shadow-md shadow-gray-700 text-base sm:text-lg">
      <div className="space-y-4">
        <h3 className="text-xl sm:text-2xl font-semibold text-red-400">
          Delete Account
        </h3>

        <p className="text-sm sm:text-base text-slate-400 leading-relaxed">
          Once you delete your account, there is no going back.
          <br />
          <strong>
            All your uploaded data and trained chatbots will be permanently
            deleted.
          </strong>{" "}
          Please be certain. This action is irreversible.
        </p>

        <div className="flex justify-end">
          <button
            onClick={() => setConfirming(true)}
            className="px-4 py-2 bg-red-500 hover:bg-red-600 rounded-md text-sm sm:text-base font-medium transition">
            Delete Account
          </button>
        </div>
      </div>

      {confirming && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-70 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full space-y-4 text-gray-800">
            <h2 className="text-lg sm:text-xl font-semibold">
              Confirm Deletion
            </h2>
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
              Are you sure you want to delete your account? This action cannot
              be undone.
            </p>
            <div className="flex justify-end space-x-2">
              <button
                onClick={() => setConfirming(false)}
                className="px-4 py-2 text-sm sm:text-base bg-gray-200 hover:bg-gray-300 rounded-md transition">
                Cancel
              </button>
              <button
                onClick={handleDeleteAccount}
                className="px-4 py-2 text-sm sm:text-base bg-red-500 hover:bg-red-600 text-white rounded-md transition">
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DangerZone;
